import { useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { api } from '../api';

export function AuthInit({ children }: { children: React.ReactNode }) {
  const { token, setUser, logout } = useAuthStore();

  useEffect(() => {
    if (!token) {
      setUser('guest', null);
      return;
    }

    api
      .getMe()
      .then((data) => {
        setUser(data.role as 'guest' | 'user' | 'admin', data.user || null);
      })
      .catch(() => {
        logout();
      });
  }, [token, setUser, logout]);

  return <>{children}</>;
}
